import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { contractConditionClassConfig } from './ContractConditionClass.name';

/** 契約状態区分のENUM */
enum ContractConditionClass {
  /** 契約中 */
  underContract = '1',
  /** 物件中途解約済 */
  articleCanceledBefMaturity = '2',
  /** 契約中途解約済 */
  contractCanceledBefMaturity = '3',
  /** 満了済 */
  expired = '5',
  /** 再リース済 */
  reLeased = '4',
  /** 再リース締結済 */
  reLeaseContractCanceled = '6',
  /** 再リース予定 */
  scheduledReLease = '7',
}

const contractConditionClassMap = new Map([
  ['1', ContractConditionClass.underContract],
  ['2', ContractConditionClass.articleCanceledBefMaturity],
  ['3', ContractConditionClass.contractCanceledBefMaturity],
  ['4', ContractConditionClass.reLeased],
  ['5', ContractConditionClass.expired],
  ['6', ContractConditionClass.reLeaseContractCanceled],
  ['7', ContractConditionClass.scheduledReLease],
]);

const rawValueToContractConditionClass = rawValueToEnumWithDefault(
  contractConditionClassMap,
  ContractConditionClass.underContract,
);

const contractConditionClassToDisplay = enumToNameWithDefault(
  ContractConditionClass,
  contractConditionClassConfig,
);

const contractConditionClassToDisplayWithPrefix = enumToNameWithDefault(
  ContractConditionClass,
  contractConditionClassConfig,
  true,
);

export {
  ContractConditionClass,
  contractConditionClassToDisplay,
  contractConditionClassToDisplayWithPrefix,
  rawValueToContractConditionClass,
};
